import { render, staticRenderFns } from "./MemberInfoPage.vue?vue&type=template&id=18cd9f03&"
import script from "./MemberInfoPage.vue?vue&type=script&lang=js&"
export * from "./MemberInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./MemberInfoPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports